import React from "react";
import { SignatureCard } from "../../../../../components";

const SignatureCardList = () => {
  return (
    <div className="my-3">
      <SignatureCard />
    </div>
  );
};

export default SignatureCardList;
